import React, { useState } from 'react';
import { Search, RotateCcw } from 'lucide-react';
import toast from 'react-hot-toast';

const TrackingSearch = ({ onSearch, isSearching, onReset, hasResult }) => {
  const [inputValue, setInputValue] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    
    const trimmedValue = inputValue.trim();
    
    if (!trimmedValue) {
      toast.error('Please enter a tracking number');
      return;
    }

    const trackingNum = parseInt(trimmedValue, 10);
    
    if (isNaN(trackingNum) || trackingNum < 1) {
      toast.error('Please enter a valid tracking number (e.g., 1, 2, 3...)');
      return;
    }

    onSearch(trackingNum);
  };

  const handleReset = () => {
    setInputValue('');
    onReset();
  };

  return (
    <div 
      className="bg-white rounded-lg shadow-lg p-6 md:p-8 mb-8"
      data-component-path="client/src/components/TrackingSearch.jsx"
      data-component-line="1:1"
      data-component-id="client/src/components/TrackingSearch.jsx:1:1"
    >
      <form 
        onSubmit={handleSubmit}
        data-component-path="client/src/components/TrackingSearch.jsx"
        data-component-line="2:3"
        data-component-id="client/src/components/TrackingSearch.jsx:2:3"
      >
        <div 
          className="flex flex-col md:flex-row gap-4"
          data-component-path="client/src/components/TrackingSearch.jsx"
          data-component-line="3:5"
          data-component-id="client/src/components/TrackingSearch.jsx:3:5"
        >
          <div 
            className="flex-1"
            data-component-path="client/src/components/TrackingSearch.jsx"
            data-component-line="4:7"
            data-component-id="client/src/components/TrackingSearch.jsx:4:7"
          >
            <label 
              htmlFor="tracking-input"
              className="block text-sm font-medium text-gray-700 mb-2"
              data-component-path="client/src/components/TrackingSearch.jsx"
              data-component-line="5:9"
              data-component-id="client/src/components/TrackingSearch.jsx:5:9"
            >
              Enter Tracking Number
            </label>
            <input
              id="tracking-input"
              type="text"
              value={inputValue}
              onChange={(e) => setInputValue(e.target.value)}
              placeholder="Enter tracking number (e.g., 1, 2, 3...)"
              className="w-full h-14 px-6 text-lg border-2 border-gray-300 rounded-lg focus:ring-4 focus:ring-blue-300/50 focus:border-blue-500 transition-all duration-200 outline-none"
              disabled={isSearching}
              data-component-path="client/src/components/TrackingSearch.jsx"
              data-component-line="6:9"
              data-component-id="client/src/components/TrackingSearch.jsx:6:9"
            />
          </div>
          
          <div 
            className="flex gap-3 md:items-end"
            data-component-path="client/src/components/TrackingSearch.jsx"
            data-component-line="7:7"
            data-component-id="client/src/components/TrackingSearch.jsx:7:7"
          >
            <button
              type="submit"
              disabled={isSearching}
              className="flex-1 md:flex-initial h-14 px-8 bg-blue-600 hover:bg-blue-700 text-white font-semibold rounded-lg flex items-center justify-center gap-2 focus:ring-4 focus:ring-blue-300/50 transition-all duration-200 shadow-md hover:shadow-lg disabled:opacity-50 disabled:cursor-not-allowed"
              data-component-path="client/src/components/TrackingSearch.jsx"
              data-component-line="8:9"
              data-component-id="client/src/components/TrackingSearch.jsx:8:9"
            >
              <Search 
                className="w-5 h-5 flex-shrink-0" 
                data-component-path="client/src/components/TrackingSearch.jsx"
                data-component-line="9:11"
                data-component-id="client/src/components/TrackingSearch.jsx:9:11"
              />
              <span data-component-path="client/src/components/TrackingSearch.jsx" data-component-line="10:11" data-component-id="client/src/components/TrackingSearch.jsx:10:11">
                {isSearching ? 'Searching...' : 'Track'}
              </span>
            </button>

            {hasResult && (
              <button
                type="button"
                onClick={handleReset}
                className="h-14 px-6 bg-gray-200 hover:bg-gray-300 text-gray-700 font-semibold rounded-lg flex items-center justify-center gap-2 focus:ring-4 focus:ring-gray-300/50 transition-all duration-200 shadow-md hover:shadow-lg"
                data-component-path="client/src/components/TrackingSearch.jsx"
                data-component-line="11:11"
                data-component-id="client/src/components/TrackingSearch.jsx:11:11"
              >
                <RotateCcw 
                  className="w-5 h-5 flex-shrink-0" 
                  data-component-path="client/src/components/TrackingSearch.jsx"
                  data-component-line="12:13"
                  data-component-id="client/src/components/TrackingSearch.jsx:12:13"
                />
                <span 
                  className="hidden md:inline"
                  data-component-path="client/src/components/TrackingSearch.jsx"
                  data-component-line="13:13"
                  data-component-id="client/src/components/TrackingSearch.jsx:13:13"
                >
                  Reset
                </span>
              </button>
            )}
          </div>
        </div>
      </form>

      <div 
        className="mt-4 text-sm text-gray-500"
        data-component-path="client/src/components/TrackingSearch.jsx"
        data-component-line="14:3"
        data-component-id="client/src/components/TrackingSearch.jsx:14:3"
      >
        <p data-component-path="client/src/components/TrackingSearch.jsx" data-component-line="15:5" data-component-id="client/src/components/TrackingSearch.jsx:15:5">
          💡 <strong>Sample tracking numbers:</strong> 1, 2, 3, 4, 5
        </p>
      </div>
    </div>
  );
};

export default TrackingSearch;